/* (c) Copyright 2020 Pivotal Software, Inc. All Rights Reserved. */
"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(ParentClass) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_ParentClass) {
    _inheritsLoose(Transition, _ParentClass);

    function Transition() {
      return _ParentClass.apply(this, arguments) || this;
    }

    var _proto = Transition.prototype;

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      _ParentClass.prototype.componentDidUpdate && _ParentClass.prototype.componentDidUpdate.call(this, prevProps, prevState);
      var open = this.state.open;
      var _this$props = this.props,
          onEntered = _this$props.onEntered,
          onExited = _this$props.onExited;
      var transitionCallback = open ? onEntered : onExited;
      var transitioning = open !== prevState.open;
      if (transitioning && transitionCallback) transitionCallback();
    };

    return Transition;
  }(ParentClass), _defineProperty(_class, "propTypes", {
    onEntered: _propTypes["default"].func,
    onExited: _propTypes["default"].func
  }), _temp;
};

exports["default"] = _default;